<template>
  <div>
BusinessPersonalCenter
  </div>
</template>
<script>
export default {
  name: 'BusinessPersonalCenter',
  data () {
    return {

    }
  },
  mounted () {

  },
  computed: {

  },
  methods: {

  }
}
</script>
<style scoped>

</style>
